import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
export const RoundTable = (genericRoundTableProps) => {
    const { RoundTable: EditorOrViewerRoundTable } = useContext(ComponentContext);
    return React.createElement(EditorOrViewerRoundTable, { ...genericRoundTableProps });
};
//# sourceMappingURL=round-table.js.map